function padNumberArray(n, padLen = 2) {
    return n.toString().padStart(padLen, "0").split("");
}
/**
 * Z: Time Zone\
 * Y: Year\
 * M: Month\
 * D: Day\
 * h: Hour\
 * m: Minute\
 * s: Second\
 * S: Millisecond\
 */
export function createKeyCharMap(date) {
    const z = date.getTimezoneOffset() / -60;
    return {
        Z: [z === 0 ? "0" : z > 0 ? `+${z}` : `-${z}`],
        Y: padNumberArray(date.getFullYear()),
        M: padNumberArray(date.getMonth() + 1),
        D: padNumberArray(date.getDate()),
        h: padNumberArray(date.getHours()),
        m: padNumberArray(date.getMinutes()),
        s: padNumberArray(date.getSeconds()),
        S: padNumberArray(date.getMilliseconds(), 3),
    };
}
//# sourceMappingURL=key-char.js.map